import { Modal as AntModal } from "antd";
import styled, { keyframes } from "styled-components";
import { TopStar, BottomStar } from '@assets';

export const Modal = styled(AntModal)`
  padding: 0px !important;
  .ant-modal-title {
    text-align: center;
    color: ${(props) => props.theme.primaryColor};
  }
  .ant-modal-content {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }

  .ant-modal-footer {
    text-align: center;
  }
`;

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  margin: 18px 0;
  height: 322px;
  width: 100%;

  @media screen and (max-width: 370px) {
    height: 272px;
  }
`;

export const Title = styled.div`
  padding-top: 14px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1;
  color: #000000;
  text-align: center;

  @media screen and (max-width: 370px) {
    padding-top: 12px;
    font-size: 14px;
  }
`;

export const LabelContainer = styled.div`
  /* padding-top: 20px; */
  padding-top: ${props => props.isPromoUser === "true" ? "60px" : "20px"};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`;

export const FirstLabel = styled.div`
  font-weight: 400;
  color: #000000;
  width: 55%;
  font-size: 11px;
  text-align: center;
  line-height: 2;
  span {
    font-weight: bold;
  }
  @media screen and (max-width: 370px) {
    font-size: 9px;
  }
`;

export const TopUpLabel = styled.div`
  font-weight: 400;
  color: #000000;
  width: 60%;
  font-size: 11px;
  text-align: center;
  line-height: 2;
  span {
    font-weight: bold;
  }
  @media screen and (max-width: 370px) {
    font-size: 9px;
  }
`;

export const TotalLabel = styled.div`
  font-weight: 400;
  color: #000000;
  width: 60%;
  font-size: 11px;
  text-align: center;
  line-height: 2;
  span {
    font-weight: bold;
  }
  @media screen and (max-width: 370px) {
    font-size: 9px;
  }
`;

export const RuleLabel = styled.div`
  padding-bottom: 8px;
  font-size: 10px;
  color: #ffffff;

  @media screen and (max-width: 370px) {
    font-size: 9px;
    padding-bottom: 4px;
  }
`;

export const BtnWrapper = styled.div`
  margin-bottom: 7px;
  display: flex;
  justify-content: center;
  gap: 10px;
  @media screen and (max-width: 370px) {
  }
`;

const pulseAnimation = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1); /* Make it slightly bigger */
  }
  100% {
    transform: scale(1);
  }
`;

export const CancelButton = styled.button`
  padding-top: 4px;
  background: -webkit-linear-gradient(to bottom, #00d7ff, #0286fb);
  background: linear-gradient(to bottom, #00d7ff, #0286fb);
  width: 123px;
  height: 36px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 12px;
  box-shadow: 0px 2px #0071e2, 0px 4px #007eef;

  @media screen and (max-width: 370px) {
    width: 100px;
    font-size: 12px;
  }
`;

export const TopStarIcon = styled(TopStar)`
  position: absolute;
  top: -8px;
  right: 0;
`;

export const BottomStarIcon = styled(BottomStar)`
  position: absolute;
  bottom: 0;
  left: -2px;
`;

export const AcceptButton = styled.button`
  padding-top: 4px;
  background: -webkit-linear-gradient(to bottom, #fff000, #edad0c);
  background: linear-gradient(to bottom, #fff000, #edad0c);
  width: 123px;
  height: 36px;
  color: #fff;
  font-size: 14px;
  text-align: center;
  border: none;
  cursor: pointer;
  border-radius: 12px;
  box-shadow: 0px 2px #ff7a00, 0px 4px #007eef;
  animation: ${pulseAnimation} 2.5s infinite;
  position: relative;

  @media screen and (max-width: 370px) {
    width: 100px;
    font-size: 12px;
  }
`;

export const LottieWrapper = styled.div`
  width: 350px;
  position: relative;

  @media screen and (max-width: 370px) {
    width: 300px;
  }
`;

export const Bottom = styled.div`
  position: absolute;
  bottom: 16px;
  width: 100%;
  text-align: center;

  @media screen and (max-width: 370px) {
    bottom: 6px;
  }
`;